// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider{border-bottom-width:1px}", "",{"version":3,"sources":["webpack://./resources/views/site/components/Divider.vue"],"names":[],"mappings":"AAMI,SAAA,uBAAe","sourcesContent":["<template>\n  <div class=\"divider\"></div>\n</template>\n\n<style>\n  .divider {\n    @apply border-b;\n  }\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
